/* import __COLOCATED_TEMPLATE__ from './submenu-header-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();